export default __webpack_public_path__ + "static/media/abstract_sculpture.33942adb.jpg";